import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { Modal } from "antd";
import { appStore } from "src/appStore";
import { t } from "i18next";
import { EntityCardStore } from "../EntityCardStore";

interface PropsEntityConfirmModal {
  store: EntityCardStore;
}

export const EntityConfirmModal: React.FC<PropsEntityConfirmModal> = observer(
  ({ store }) => {
    useEffect(() => {
      store.clearConfirmation();
    }, [appStore.userData]);
    return (
      <Modal
        open={!!store.onConfirm}
        onOk={() => store.confirmClosure()}
        onCancel={() => store.setOnConfirm(null)}
        okText={t("Continue")}
        okButtonProps={{ danger: true }}
        centered
      >
        <div>
          {t("The form contains unsaved data. Continue with data loss?")}
        </div>
      </Modal>
    );
  },
);
